// extracted by mini-css-extract-plugin
export default {"bar-title":"StatisticsPage_bar-title__Q68Gx"};